// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function WarningIcon(Props) {
  var fill_color = Props.fill_color;
  var inner_stroke_color = Props.inner_stroke_color;
  var outer_stroke_color = Props.outer_stroke_color;
  return React.createElement("svg", {
              id: "warning-icon",
              height: "19",
              width: "23",
              fill: "none",
              viewBox: "0 0 23 19",
              xmlns: "http://www.w3.org/2000/svg"
            }, React.createElement("path", {
                  id: "warning",
                  d: "M2.16316 18C1.98453 18 1.82215 17.9567 1.676 17.8701C1.52985 17.7836 1.41617 17.6694 1.33498 17.5278C1.25379 17.3861 1.20913 17.2326 1.20101 17.0674C1.19289 16.9021 1.23755 16.7407 1.33498 16.5833L10.3475 1.47222C10.445 1.31481 10.5708 1.19676 10.7251 1.11806C10.8794 1.03935 11.0377 1 11.2001 1C11.3625 1 11.5208 1.03935 11.6751 1.11806C11.8293 1.19676 11.9552 1.31481 12.0526 1.47222L21.0652 16.5833C21.1626 16.7407 21.2073 16.9021 21.1991 17.0674C21.191 17.2326 21.1464 17.3861 21.0652 17.5278C20.984 17.6694 20.8703 17.7836 20.7242 17.8701C20.578 17.9567 20.4156 18 20.237 18H2.16316Z",
                  fill: fill_color,
                  stroke: outer_stroke_color,
                  strokeWidth: "2"
                }), React.createElement("path", {
                  id: "warning_2",
                  d: "M11.5804 14.1867C11.4901 14.267 11.3748 14.316 11.2001 14.316C11.0254 14.316 10.9101 14.267 10.8198 14.1867C10.7326 14.1093 10.7001 14.0332 10.7001 13.9271C10.7001 13.821 10.7326 13.7449 10.8198 13.6675C10.9101 13.5872 11.0254 13.5382 11.2001 13.5382C11.3748 13.5382 11.4901 13.5872 11.5804 13.6675C11.6675 13.7449 11.7001 13.821 11.7001 13.9271C11.7001 14.0332 11.6675 14.1093 11.5804 14.1867L11.8493 14.4892L11.5804 14.1867ZM11.5804 11.5201C11.4901 11.6003 11.3748 11.6493 11.2001 11.6493C11.0254 11.6493 10.9101 11.6003 10.8198 11.5201C10.7326 11.4426 10.7001 11.3665 10.7001 11.2604V7.70487C10.7001 7.59879 10.7326 7.5227 10.8198 7.44524C10.9101 7.36498 11.0254 7.31598 11.2001 7.31598C11.3748 7.31598 11.4901 7.36498 11.5804 7.44524C11.6675 7.5227 11.7001 7.59878 11.7001 7.70487V11.2604C11.7001 11.3665 11.6675 11.4426 11.5804 11.5201Z",
                  fill: fill_color,
                  stroke: inner_stroke_color
                }));
}

var make = WarningIcon;

export {
  make ,
  
}
/* react Not a pure module */
